import React, { useEffect, useState } from 'react';
import { Typography, Button } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { observer } from 'mobx-react';
import { getParent } from 'mobx-state-tree';
import { getParentRenderProps } from '@jbrowse/core/util/tracks';
import RefreshIcon from '@mui/icons-material/Refresh';
const useStyles = makeStyles()(theme => ({
    loading: {
        paddingLeft: '0.6em',
        backgroundColor: theme.palette.action.disabledBackground,
        backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 5px, rgba(255,255,255,.5) 5px, rgba(255,255,255,.5) 10px)',
        height: '100%',
        width: '100%',
        pointerEvents: 'none',
        textAlign: 'center',
    },
    blockMessage: {
        width: '100%',
        background: theme.palette.action.disabledBackground,
        padding: theme.spacing(2),
        pointerEvents: 'none',
        textAlign: 'center',
    },
    blockError: {
        padding: theme.spacing(2),
        width: '100%',
        whiteSpace: 'normal',
        color: theme.palette.error.main,
        overflowY: 'auto',
    },
    blockReactNodeMessage: {
        width: '100%',
        background: theme.palette.action.disabledBackground,
        padding: theme.spacing(2),
        textAlign: 'center',
    },
    dots: {
        '&::after': {
            display: 'inline-block',
            animation: '$ellipsis 1.5s infinite',
            content: '"."',
            width: '1em',
            textAlign: 'left',
        },
    },
    '@keyframes ellipsis': {
        '0%': {
            content: '"."',
        },
        '33%': {
            content: '".."',
        },
        '66%': {
            content: '"..."',
        },
    },
}));
function Repeater({ children }) {
    return (React.createElement("div", { style: { display: 'flex' } },
        children,
        children));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const LoadingMessage = observer(({ model }) => {
    // only show the loading message after 300ms to prevent excessive flickering
    const [shown, setShown] = useState(false);
    const { classes } = useStyles();
    useEffect(() => {
        let killed = false;
        const timeout = setTimeout(() => {
            if (!killed) {
                setShown(true);
            }
        }, 300);
        return () => {
            clearTimeout(timeout);
            killed = true;
        };
    }, []);
    const { status: blockStatus } = model;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { message: displayStatus } = getParent(model, 2);
    const status = displayStatus || blockStatus;
    return (React.createElement(React.Fragment, null, shown ? (React.createElement("div", { className: classes.loading },
        React.createElement(Typography, { className: classes.dots, variant: "body2" }, status ? `${status}` : 'Loading'))) : null));
});
function BlockMessage({ messageContent, }) {
    const { classes } = useStyles();
    return React.isValidElement(messageContent) ? (React.createElement("div", { className: classes.blockReactNodeMessage }, messageContent)) : (React.createElement(Typography, { variant: "body2", className: classes.blockMessage }, messageContent));
}
function BlockError({ error, reload, displayHeight, }) {
    const { classes } = useStyles();
    return (React.createElement("div", { className: classes.blockError, style: { height: displayHeight } },
        reload ? (React.createElement(Button, { "data-testid": "reload_button", onClick: reload, startIcon: React.createElement(RefreshIcon, null) }, "Reload")) : null,
        React.createElement(Typography, { color: "error", variant: "body2", display: "inline" }, `${error}`)));
}
const ServerSideRenderedBlockContent = observer(({ model, }) => {
    if (model.error) {
        return (React.createElement(Repeater, null,
            React.createElement(BlockError, { error: model.error, reload: model.reload, displayHeight: getParentRenderProps(model).displayModel.height })));
    }
    if (model.message) {
        return (React.createElement(Repeater, null,
            React.createElement(BlockMessage, { messageContent: model.message })));
    }
    if (!model.filled) {
        return (React.createElement(Repeater, null,
            React.createElement(LoadingMessage, { model: model })));
    }
    return model.reactElement;
});
export default ServerSideRenderedBlockContent;
//# sourceMappingURL=ServerSideRenderedBlockContent.js.map